<template>
    <vs-popup :active.sync="isActive" v-esc="escape" title="Kasadan Nakit Çıkışı">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
          <v-select v-show="false" class="w-full" name="Ödeme Tipi" placeholder="Ödeme Tipi" v-model="newExpense.paymentMethod"
          disabled="disabled"   itemid="id" label="name" v-validate="'required'" :options="paymentMethods" :clearable="false" />
          <span class="text-danger text-sm" v-show="errors.has('Ödeme Tipi')">{{ errors.first('Ödeme Tipi') }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-w="4" class="pr-1">
            <datepicker v-show="false" :highlighted="highlightedFn" class="w-full bg-white" :language="turkish" format="d MMMM yyyy"
            disabled="disabled"    v-model="newExpense.date"></datepicker>
          </vs-col>
          <vs-col v-show="false" vs-type="flex" vs-w="4" class="pr-1">
            <vue-timepicker class="w-full bg-white orderLogTimeFilter" :language="turkish" placeholder="Saat"
            disabled="disabled"      v-model="newExpense.time"></vue-timepicker>
          </vs-col>
          <vs-col v-show="false" vs-type="flex" vs-w="4">
            <vs-input id="price" disabled="disabled" 
            v-model="activePersonal.name" class="w-full" />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <v-select :disabled="expenseDefinitions.length == 0" id="expenseDefinition" name="Gider Tipi"
            @input="newExpense.description = newExpense.expenseDefinition.description" v-validate="'required'"
            v-model="newExpense.expenseDefinition" itemid="id" label="name" placeholder="Gider Tipi Seçimi.."
            :options="expenseDefinitions" class="w-full" :clearable="false"></v-select>
          <span class="text-danger text-sm w-full"
            v-show="errors.has('Gider Tipi')">{{ errors.first('Gider Tipi') }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-input id="price" name="Tutar" v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,min_value:1}"
            v-model="newExpense.price" class="w-full" placeholder="Tutar" @input="handleInput"/>
          <span class="text-danger text-sm" v-show="errors.has('Tutar')">{{ errors.first("Tutar")}}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-textarea id="decription" name="Açıklama" v-validate="'required|max:100'" v-model="newExpense.description"
            class="w-full mb-0" label="Açıklama" />
          <span class="text-danger text-sm" v-show="errors.has('Açıklama')">{{ errors.first('Açıklama') }}</span>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-4">
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-end">
            <vs-button @click="isActive = false;" size="large" color="danger" type="gradient" icon-pack="feather"
              icon="icon-arrow-left" class="bold mr-2">
              Vazgeç
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" vs-justify="flex-start">
            <vs-button @click="submitData" size="large" color="transparent" class="bold bg-success text-white ml-2">
              Onayla
            </vs-button>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>
  </template>
  
  <script>
    import VueTimepicker from "vue2-timepicker";
    import "vue2-timepicker/dist/VueTimepicker.css";
    import {
      tr
    } from "vuejs-datepicker/src/locale";
    import Datepicker from "vuejs-datepicker";
    import {
      getPaymentMethodList
    }
    from "@/api/PaymentMethod";
    import {
      getExpenseDefinitionNameList
    } from '@/api/ExpenseDefinition';
    import {
      createNewExpense,
      updateExpense
    } from "@/api/Expense";
    export default {
      components: {
        VueTimepicker,
        Datepicker
      },
      data() {
        return {
          isActive: false,
          newExpense: {
            paymentMethod: {
        name: "Kasa Nakit",
        type: "Single",
        effect: "Pozitif",
        originPaymentMethod: {
            name: "Diğer",
            type: "SolidRoot",
            effect: "Pozitif",
            originPaymentMethod: null,
            originPaymentMethodId: null,
            id: 3
        },
        originPaymentMethodId: 3,
        id: 25
    },
          },
          paymentMethods: [],
          expenseDefinitions: [],
          highlightedFn: {
            customPredictor(date) {
              if (date.toISOString().slice(0, 10) === new Date(Date.now()).toISOString().slice(0, 10)) {
                return true;
              }
            }
          },
          format: "dd MM yyyy ",
          turkish: tr,
        }
      },
      computed:{
        activePersonal: {
      get() {
        return this.$store.getters["selfservice/getActivePersonal"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
      },
      methods: {
        handleInput() {
      // Girilen değeri kontrol et
      if (this.newExpense.price !== null) {
        // Sayı ve en fazla iki ondalık basamak kontrolü
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.newExpense.price)) {
          // Geçersiz giriş, uygun bir işlem yapabilirsiniz (örneğin, kullanıcıyı uyarabilirsiniz)
          this.newExpense.price = this.newExpense.price.replace(/[^\d.]+/g, '').replace(/(\.\d{0,2})\./g, '$1').replace(/^\./, '').replace(/^(\d+\.\d{2}).*$/, '$1');
        }
      }
    },
        getPaymentMethodList: async function () {
          try {
            let response = await getPaymentMethodList();
            this.paymentMethods = response;
          } catch (e) {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: e.message
            });
          }
        },
        escape() {
          if (this.isActive) this.isActive = false;
        },
        submitData: async function () {
          let checker = await this.$validator.validateAll();
          if (!checker) return;
          this.newExpense.user = {};
          this.newExpense.branch = {};
          this.newExpense.paymentMethod = {
        name: "Kasa Nakit",
        type: "Single",
        effect: "Pozitif",
        originPaymentMethod: {
            name: "Diğer",
            type: "SolidRoot",
            effect: "Pozitif",
            originPaymentMethod: null,
            originPaymentMethodId: null,
            id: 3
        },
        originPaymentMethodId: 3,
        id: 25
    },
          this.newExpense.user.id = this.$currentUser.id;
          this.newExpense.branch.id = this.$currentUser.branch.id;
          this.newExpense.price = parseFloat(this.newExpense.price);
          this.newExpense.date = new Date(this.newExpense.date)
          if (!this.newExpense.id) {
            createNewExpense(this.newExpense).then(res => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Gider Eklendi!"
                });
                this.isActive = false;
                this.$emit("saveExpense", res.data);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Gider Eklenemedi !"
                });
              }
            }).catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: error.response.data.Errors[0].Message,
              });
            });
          } else {
            updateExpense(this.newExpense).then(res => {
              if (res && res.status == 200) {
                this.$emit("updateExpense", this.newExpense);
                this.isActive = false;
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Gider Kaydı Güncellenemedi !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        },
        initValues() {
          this.$validator.reset();
          let now = new Date(Date.now())
          let hour = now.getHours();
          let minute = now.getMinutes();
          if(hour < 10) hour = '0' + hour;
          if(minute < 10) minute = '0' + minute;
          this.newExpense = {date : this.$now.date().toString(), time: hour + ':' + minute};
          this.getPaymentMethodList();
        },
        getExpenseDefinitions() {
          getExpenseDefinitionNameList().then(res => {
            if (res && res.status == 200) {
              this.expenseDefinitions = res.data;
            } else {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata : ' + res.status,
                text: 'Gider Tipleri Yüklenemedi !'
              });
            }
          }).catch(x => {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata !',
              text: 'Sunucu Bağlantı Hatası !'
            });
          });
        }
      },
      watch: {
        isActive(val) {
          this.initValues();
          this.newExpense.paymentMethod= "Kasa Nakit";
          console.log(this.newExpense);
          if (!val) this.$emit("close");
        }
      },
      created() {
        this.getExpenseDefinitions();
      }
    }
  
  </script>
  
  <style>
  .orderLogTimeFilter input {
    padding: .7em .5em !important;
    border-radius: .4rem;
    width: 100% !important;
    height: unset !important;
    background: white;
  }
  .disabled{
    background: white !important;
  }
  </style>
  